import React, {useState} from 'react';

import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import PageEditor from 'typescript/models/PageEditor';

import './PageEditorsMobile.scss';
import {PageEditorDropdownMobile} from '../PageEditorDropdown/PageEditorDropdownMobile/PageEditorDropdownMobile';

interface IProps {
  pubEditors: PageEditor[];
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PageEditorsMobile = ({setIsDropdownOpen, pubEditors}: IProps) => {
  const [showContent, setShowContent] = useState(false);

  const openDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
    setShowContent((prevState) => !prevState);
  };

  return (
    <div className="pub__page-editors-mobile">
      <div className="dropdown">
        <div className="dropdown__main" role="button" onClick={openDropdown}>
          <Text tag="span" className="dropdown__title">
            Pub Page Editors
          </Text>
          <div className={`dropdown__icon${showContent ? ' dropdown__icon--rotate' : ''}`}>
            <Icon icon="chevron-down" />
          </div>
        </div>
      </div>
      {showContent && <PageEditorDropdownMobile pubEditors={pubEditors} />}
    </div>
  );
};
